angular.module("tromanWeb").directive("ergoSelectText", ['$timeout', function ($timeout) {
    return {
        restrict: "A",
        priority: -1,
        require: ["?ngModel"],
        link: function (_scope, element, _attributes, controllers) {

            var ngModelController = controllers[0];
            if (!ngModelController) return;

            var oldRender = ngModelController.$render;
            ngModelController.$render = function () {
                oldRender.apply(this, arguments);
                $timeout(function () {
                    element.select();
                    element.focus();
                });
            };
        }
    };
}]);

angular.module("tromanWeb").directive("ergoFocusOn", ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            var getter = $parse(attr.ergoFocusOn);
            if (!getter) return;
            var setter = getter.assign;
            if (!setter) return;

            scope.$watch(getter, function (val) {
                if (val) {
                    element.focus();
                    setter(scope, false);
                }
            });
        }
    };
}]);
